import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { PipesModule } from '../../pipes/pipes.module';
import { PopupFileBrowserComponent } from './popup-file-browser.component';

@NgModule({
    declarations: [PopupFileBrowserComponent],
    imports: [CommonModule, TwcModule, TranslateModule, PipesModule, FormsModule],
    exports: [PopupFileBrowserComponent],
})
export class PopupFileBrowserModule {}
